<template lang="pug">
#admin_container.container-small
  h1#container_title 관리자메인
  .container_wr
    .visit_chart(style="float:left;width:49%;margin-right:1%;")
      .spinner(v-if="barSpin")
        font-awesome-icon.fas.fa-spin.fa-lg(icon="circle-notch")
      section(v-else)
        div(style='width: 100%;')
          bar-chart(:chartdata='barChartdata')
    .visit_day(style="float:left;width:49%;margin-left:1%;")
      .spinner(v-if="lineSpin")
        font-awesome-icon.fas.fa-spin.fa-lg(icon="circle-notch")
      section(v-else)
        div
          line-chart(:chartdata='lineChartdata' :sum='sum')
    div(style="clear: both;")
    hr(style="margin: 30px 0;")
    .visit_device(style="float:left;width:49%;margin-right:1%;")
      .spinner(v-if="pieSpin")
        font-awesome-icon.fas.fa-spin.fa-lg(icon="circle-notch")
      #canvas-holder(v-else)
        doughnut-chart(:chartdata='pieChartdata')
    
    div(style="clear: both;")
    hr(style="margin: 30px 0;")
    
</template>

<script>
import BarChart from './Chart/BarChart.vue';
import LineChart from './Chart/LineChart.vue';
import DoughnutChart from './Chart/DoughnutChart.vue';
import ChartDataLabels from 'chartjs-plugin-datalabels';
export default {
  components: {
    BarChart,
    LineChart,
    DoughnutChart,
  },
  data() {
    return {
      barSpin: false,
      lineSpin: false,
      pieSpin: false,
      sum: 0,
      barChartdata: {
        labels: [],
        datasets: [
          {
            label: '방문자수',
            backgroundColor: '#59aee7a6',
            borderWidth: 2,
            pointBorderColor: '#6dbbef',
            data: [],
          },
        ],
      },
      lineChartdata: {
        labels: [],
        datasets: [
          {
            label: '최근1달',
            fill: false,
            backgroundColor: '#ff6384',
            borderColor: '#ff6384',
            borderWidth: 2,
            data: [],
          },
          {
            label: '2달전',
            fill: false,
            backgroundColor: '#36a2eb',
            borderColor: '#36a2eb',
            data: [],
          },
          {
            label: '3달전',
            fill: false,
            backgroundColor: '#ffcd56',
            borderColor: '#ffcd56',
            data: [],
          },
        ],
      },
      pieChartdata: {
        labels: ['PC', 'MOBILE'],
        datasets: [
          {
            backgroundColor: ['#4bc0c0', '#36a2eb'],
            data: [],
            datalabels: {
              anchor: 'center',
              backgroundColor: null,
              borderWidth: 0,
            },
          },
        ],
      },
    };
  },
  computed: {},
  methods: {
    async getBarChartData() {
      this.barSpin = true;
      await this.$_admin_get('admin/ga', { category: 'week' }).then(res => {
        let labels = res.data.res[0];
        labels.forEach((e, i) => {
          labels[i] = this.$moment(e).format('MM-DD (dd)');
        });
        this.barChartdata.labels = labels;
        this.barChartdata.datasets[0].data = res.data.res[1];
        this.barSpin = false;
      });
    },
    async getLineChartData() {
      this.lineSpin = true;
      await this.$_admin_get('admin/ga', { category: 'dayofweek' }).then(
        res => {
          let $_res = res.data.res;
          this.lineChartdata.datasets[2].data = $_res[0];
          this.lineChartdata.datasets[1].data = $_res[1];
          this.lineChartdata.datasets[0].data = $_res[2];

          for (var i = 0; i < 3; i++) {
            let sum = $_res[i].reduce(function add(sum, currentValue) {
              return sum + currentValue;
            }, 0);
            this.sum += sum;
          }

          let labels = [
            '월요일',
            '화요일',
            '수요일',
            '목요일',
            '금요일',
            '토요일',
            '일요일',
          ];
          this.lineChartdata.labels = labels;
          this.lineSpin = false;
        },
      );
    },
    async getPieChartData() {
      this.pieSpin = true;
      await this.$_admin_get('admin/ga', { category: 'device' }).then(res => {
        this.pieChartdata.datasets[0].data = res.data.res[1];
        this.pieSpin = false;
      });
    },
  },
  mounted() {
    this.getBarChartData();
    this.getLineChartData();
    this.getPieChartData();
  },
  beforeMount() {},
  created() {},
};
</script>

<style scoped>
@import '../../assets/css/admin.css';
#admin_container {
  height: 100%;
}
#admin_container .container_wr {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  height: 100%;
}
.container_wr div section {
  padding: 0;
}
.container_wr .visit_device {
  margin-top: 30px;
}
.center {
  text-align: center;
}
.spinner {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
